import React, { useEffect, useRef } from "react";
import { trackEvent } from "@utils/analytics";
import * as c from "./desktopNavbarItems.module.scss";
import { Link } from "gatsby";

import { DropdownFeatures, DropdownBusinessTypes } from "./dropdowns";
import { Button } from "@components/shared";
import { useLocation } from "@reach/router";
import { competitorComparisonPageSlugs } from "@utils/competitorComparisonPage";

export default function DesktopNavbarItems() {
  const location = useLocation();
  const navRef = useRef(null);
  const currentSlug = location.pathname
    .split("/")
    .filter((x) => x)
    .pop();
  const isCompetitorComparisonPage = competitorComparisonPageSlugs.includes(currentSlug);

  const DesktopNavbarLink = ({ to, label }) => {
    return (
      <li className={c.item}>
        <Link className={c.link} to={to}>
          {label}
        </Link>
      </li>
    );
  };

  useEffect(() => {
    // Setting active states and updating transition duration helps ensure elements enter in the correct position on initial hover
    navRef.current.style.setProperty("--transition-duration", "0s");
    const setActiveState = () => {
      setTimeout(() => {
        navRef.current.style.setProperty("--transition-duration", "0.2s");
      }, 200);
    };
    const removeActiveState = () => {
      navRef.current.style.setProperty("--transition-duration", "0s");
    };
    navRef.current.addEventListener("mouseenter", setActiveState);
    navRef.current.addEventListener("mouseleave", removeActiveState);
    return () => {
      if (navRef.current) {
        navRef.current.removeEventListener("mouseenter", setActiveState);
        navRef.current.removeEventListener("mouseleave", removeActiveState);
      }
    };
  }, []);

  return (
    <div className={c.navbarDesktop}>
      <ul id={"desktopNavbarItems"} className={c.navbarItems} ref={navRef} style={{ "--dropdown-height": "330px" }}>
        {/* Business types */}
        <DropdownBusinessTypes />

        {/* Features */}
        <DropdownFeatures />

        {/* Pricing */}
        <DesktopNavbarLink to="/pricing/" label="Pricing" />

        {/* Why Mangomint */}
        {!isCompetitorComparisonPage && <DesktopNavbarLink to="/why-mangomint/" label="Why Mangomint" />}
      </ul>

      {/* eslint-disable-next-line react/jsx-no-target-blank */}
      <a className={c.link} href="https://app.mangomint.com/" target="_blank">
        Log in
      </a>
      <Button
        linkTo="/demo/"
        variant="outline"
        className={c.demoButton}
        onClick={() => trackEvent("Desktop Nav: Demo CTA Clicked")}
      >
        Book a demo
      </Button>
      <Button
        linkTo="/trial/"
        variant="full"
        className={c.trialButton}
        onClick={() => trackEvent("Desktop Nav: Trial CTA Clicked")}
      >
        Try it now
      </Button>
    </div>
  );
}
